
import { Component, Mixins } from "vue-property-decorator";
import LineChart from "@pazion/pazion-catalog/src/components/chart/LineChart.vue";
import PazStockMutationDialog from "@pazion/pazion-catalog/src/components/dialog/PazStockMutationDialog.vue";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import { DataTableHeader } from "vuetify";
import {
  getAllProducts,
  getStock,
  getStockDownload,
  getStockTransactionTypes,
  getWarehouses,
} from "@pazion/pazion-catalog/src/services/catalog-service";
import { formatDate } from "@pazion/pazion-catalog/src/helpers/format";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import {
  IStockMutationTransactionType,
  IStockResponseItem,
} from "@pazion/pazion-catalog/src/models/stock";
import { IProduct } from "@pazion/pazion-catalog/src/models/product";
import { IWarehouse } from "@pazion/pazion-catalog/src/models/warehouse";
import { uploadFlowFileToQueue } from "@pazion/pazion-core/src/services/base-service";
import FileUploader from "@pazion/pazion-core/src/components/common/FileUploader.vue";
import fileSaver from "file-saver";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";

@Component({
  components: {
    LineChart,
    PazRefreshButton,
    PazTooltipButton,
    PazStockMutationDialog,
    PazToast,
    PazConfirmation,
    FileUploader,
  },
  methods: {
    formatDate,
  },
})
export default class Stock extends Mixins(PermissionService) {
  $refs!: {
    toast: PazToast;
    confirm: PazConfirmation;
    confirmUploadFile: PazConfirmation;
    confirmDeleteStock: PazConfirmation;
  };
  public products: IProduct[] = [];
  public transactionTypes: IStockMutationTransactionType[] = [];
  public warehouses: IWarehouse[] = [];

  public stockItems: IStockResponseItem[] = [];
  public stockTableHeaders: DataTableHeader[] = [
    {
      text: "id",
      align: "start",
      sortable: false,
      value: "mutation.id",
      width: 13,
    },
    {
      text: "Mutation date",
      align: "start",
      sortable: true,
      value: "mutationDate",
    },
    {
      text: "SKU",
      align: "start",
      sortable: true,
      value: "product.sku",
    },
    {
      text: "Description",
      align: "start",
      sortable: true,
      value: "productDescription",
    },
    {
      text: "Transactions type",
      align: "start",
      sortable: true,
      value: "transactionType",
    },
    {
      text: "Warehouse",
      align: "start",
      sortable: true,
      value: "warehouse",
    },
    {
      text: "Quantity",
      align: "start",
      sortable: true,
      value: "quantity",
    },
  ];
  public footer: object = {
    "items-per-page-options": [50, 100, 200],
  };
  public uploadedFile: File | null = null;
  public search: string = "";
  public showStockDialog: boolean = false;
  public loading: boolean = true;
  public downloading: boolean = false;

  createNewStock() {
    this.switchStockDialog();
  }

  async downloadCurrentStockFile() {
    this.downloading = true;
    const stockBlob = await getStockDownload();
    // console.log(stockBlob);
    // console.log(typeof stockBlob);
    const blob = new Blob([stockBlob], { type: "csv" });
    fileSaver.saveAs(blob, "current_stock.csv");
    this.downloading = true;
  }

  async showCsvStockDialog() {
    //help
    const confirm = await this.$refs.confirmUploadFile.openConfirmDialog(
      "Upload Stock file",
      ``
    );
    if (confirm && this.uploadedFile) {
      let rsp = await uploadFlowFileToQueue(
        "stock-csv-import-file",
        this.uploadedFile,
        false,
        ","
      );
      if (rsp.success) {
        this.$refs.toast.show({ message: "Added stock file to queue" });
      } else {
        this.$refs.toast.show({
          message: "Failed to add file to queue!",
          color: "red",
          icon: "mdi-close-circle",
        });
      }
    }
  }
  async onFileSelect(file: File) {
    this.uploadedFile = file;
  }
  switchStockDialog() {
    this.showStockDialog = !this.showStockDialog;
  }

  async fetchData() {
    this.loading = true;
    this.stockItems = await getStock();
    this.products = await getAllProducts();
    this.transactionTypes = await getStockTransactionTypes();
    this.loading = false;
    this.warehouses = await getWarehouses();
  }

  created() {
    this.fetchData();
  }
}
